/**
 * @desc 获取实例历史任务变量
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<Array<ObjectMap<string, ObjectMap>>>;
export function request(
  params: API.activiti.business.historyInstanceTaskVariable.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/business/historyInstanceTaskVariable`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
